import { API_URL, jwtToken } from "../../../context/appContext";
export default async function testProfile(profile) {
    return fetch(`${API_URL}/api/profile/test`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        },
        body: JSON.stringify(profile)
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
